import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PaginatedResults } from '../../models/paginated_results_model';
import { PaginationOptions } from '../../models/pagination_options';
import { LoadingFormat } from '../../models/loading-format';

@Injectable({
  providedIn: 'root',
})
export class LoadingFormatService {
  currentDomain = environment.currentApiHostname;
  apiUrl = `https://${this.currentDomain}/api/general`;

  constructor(private http: HttpClient) {}

  get(paginationOptions: PaginationOptions) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<PaginatedResults>(
      this.apiUrl +
        `/loading-formats?${PaginationOptions.getPaginationQueryParameters(
          paginationOptions
        )}`,
      options
    );
  }

  all() {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<Array<LoadingFormat>>(
      this.apiUrl + `/loading-formats/index/all`,
      options
    );
  }

  export(type: string, paginationOptions: PaginationOptions) {
    const options = {
      responseType: 'blob' as 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get(
      this.apiUrl +
        `/exports/loading-formats/export/${type}?${PaginationOptions.getPaginationQueryParameters(
          paginationOptions
        )}`,
      options
    );
  }

  show(uuid: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<LoadingFormat>(
      this.apiUrl + `/loading-formats/${uuid}`,
      options
    );
  }

  store(payload: any) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.post<LoadingFormat>(
      this.apiUrl + `/loading-formats`,
      payload,
      options
    );
  }

  update(payload: any, uuid: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.post<LoadingFormat>(
      this.apiUrl + `/loading-formats/update/${uuid}`,
      payload,
      options
    );
  }
}
